/**
 * Consent Check Step
 */

import React from 'react';
import { ConsentGate } from '@/components/consent';

interface ConsentCheckStepProps {
  clinicId: string;
  patientId: string;
  patientName: string;
  onComplete: () => void;
  onCancel: () => void;
}

export const ConsentCheckStep: React.FC<ConsentCheckStepProps> = ({
  clinicId,
  patientId,
  patientName,
  onComplete,
  onCancel,
}) => {
  return (
    <div>
      <h2 className='mb-2 text-2xl font-bold text-slate-900'>Review Required Forms</h2>
      <p className='mb-8 text-slate-500'>
        Please review and sign any required consent forms before booking your appointment
      </p>

      <ConsentGate
        clinicId={clinicId}
        patientId={patientId}
        patientName={patientName}
        purpose='booking'
        onComplete={onComplete}
        onCancel={onCancel}
      />
    </div>
  );
};

